import {     
    apiGet,
    apiPost,
    apiPut,
    apiDelete,
    buildFormData
} from '@api/api.utils'

import { IResponseCommon } from "../common.types"

import { 
    IResponseCommercialOffers, IResponseCommercialOfferCard,
    IResponseCommercialOfferCardSave,
    IResponseCommercialOfferProgramCardSave,
    IResponseCommercialOfferFiles,
} from "./api.types"

import { 
    ICommercialOfferCardSendedData,
    ICommercialOfferCardProgramsSendedData,
} from "./state.types"


const route = '/commercialOffers'


/** Получение коммерческих предложений */
export const getCommercialOffers = (pageNumber: number, search?: string, accessSites?: string, signal?: AbortSignal): Promise<IResponseCommercialOffers> => 
    apiGet<IResponseCommercialOffers>(`${route}/getCommercialOffers`, {params: {pageNumber, search, accessSites}, signal})

/** Получение данных по анкете */
export const getCommercialOfferCard = (commercialOfferID: number): Promise<IResponseCommercialOfferCard> => 
    apiGet<IResponseCommercialOfferCard>(`${route}/getCommercialOfferCard`, {params: {commercialOfferID}})

/** Получение файлов коммерческого предложения */
export const getCommercialOfferFiles = (commercialOfferID: number): Promise<IResponseCommercialOfferFiles> => 
    apiGet<IResponseCommercialOfferFiles>(`${route}/getCommercialOfferFiles`, {params: {commercialOfferID}})

/** Сохранение данных по анкете */
export const setCommercialOfferCardSave = (commercialOfferID: number, data: ICommercialOfferCardSendedData): Promise<IResponseCommercialOfferCardSave> => 
    apiPut<IResponseCommercialOfferCardSave>(`${route}/setCommercialOfferCardSave`, {params: {commercialOfferID}}, {commercialOfferData: data})

/** Удаление программы из коммерческого предложения */
export const setCommercialOfferProgramCardDelete = (commercialOfferProgramID: number): Promise<IResponseCommon> => 
    apiDelete<IResponseCommon>(`${route}/setCommercialOfferProgramCardDelete`, {params: {commercialOfferProgramID}})

/** Добавление/Редактирование программы по коммерческому предложению */
export const setCommercialOfferProgramCardSave = (commercialOfferID: number, data: ICommercialOfferCardProgramsSendedData): Promise<IResponseCommercialOfferProgramCardSave> => 
    apiPut<IResponseCommercialOfferProgramCardSave>(`${route}/setCommercialOfferProgramCardSave`, {params: {commercialOfferID}}, {commercialOfferProgramData: data})

/** Загрузка файлов коммерческого предложения на сервер */
export const setCommercialOfferUploadFiles = (commercialOfferID: number, files: File[]): Promise<IResponseCommon> => {
    const formData = buildFormData({docs: files})
    return apiPost<IResponseCommon>(`${route}/setCommercialOfferUploadFiles`, {params: { commercialOfferID }}, formData)
}

/** Удаление файлов по коммерческому предложению */
export const setCommercialOfferDeleteFiles = (commercialOfferID: number, fileID: number): Promise<IResponseCommon> => 
    apiDelete<IResponseCommon>(`${route}/setCommercialOfferDeleteFiles`, {params: {commercialOfferID, fileID}})

/** Формирование документов по коммерческому предложению */
export const setCommercialOfferGenerateDocument = (commercialOfferID: number, documents: any[]): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/setCommercialOfferGenerateDocument`, {params: {commercialOfferID}}, {documents})

/** Отправка сообщений в telegram канал (ИКТ - КП клиенту) */
export const sendTelegramMessageClientKP = (commercialOfferID: number): Promise<IResponseCommon> => 
    apiPost<IResponseCommon>(`${route}/sendTelegramMessageClientKP`, {params: {commercialOfferID}})